module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp3_5010.2ab576a9.png";